import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { AssetTypeSettingsStatusViewTopBar } from "./TopBar"

export const assetTypeStatusViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: AssetTypeSettingsStatusViewTopBar,
}
